import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateVehicleGroupDto } from './create-vehicle-group.dto';

/**
 * Update vehicle group DTO
 */
export class UpdateVehicleGroupDto extends CreateVehicleGroupDto {
  @TransformInt()
  id!: number;
}
